import { BLUEPRINT_NAMES } from './blueprintNameMapping.ts';
import { WHITEBOARD_TEMPLATE_IDS } from './whiteboardMappings.ts';

export const subAnchorToTemplatesMapping: {
	[key: string]: Array<WHITEBOARD_TEMPLATE_IDS | BLUEPRINT_NAMES>;
} = {
	'ONLINE FLOWCHART': [
		WHITEBOARD_TEMPLATE_IDS.CONCEPT_MAP,
		WHITEBOARD_TEMPLATE_IDS.FLOWCHART,
		WHITEBOARD_TEMPLATE_IDS.SWIMLANES_PROCESS_MAP,
		WHITEBOARD_TEMPLATE_IDS.FISHBONE_DIAGRAM,
	],
	'BUSINESS PLAN': [
		BLUEPRINT_NAMES.BUSINESS_PLAN_ONE_PAGER,
		BLUEPRINT_NAMES.STRATEGIC_PLAN,
		WHITEBOARD_TEMPLATE_IDS.SWOT_ANALYSIS,
		BLUEPRINT_NAMES.STANDARD_OPERATING_PROCEDURE_TEMPLATE,
		WHITEBOARD_TEMPLATE_IDS.FOCUS_AREA_DIAGRAM,
		BLUEPRINT_NAMES.COMPETITIVE_ANALYSIS,
		BLUEPRINT_NAMES.PROJECT_PLAN,
		BLUEPRINT_NAMES.MARKETING_PLAN,
	],
	'DIGITAL DIAGRAM': [
		WHITEBOARD_TEMPLATE_IDS.USER_STORY_MAP,
		WHITEBOARD_TEMPLATE_IDS.FLOWCHART,
		WHITEBOARD_TEMPLATE_IDS.CONCEPT_MAP,
		WHITEBOARD_TEMPLATE_IDS.SWIMLANES_PROCESS_MAP,
		WHITEBOARD_TEMPLATE_IDS.FISHBONE_DIAGRAM,
	],
	'PROJECT PLAN': [
		BLUEPRINT_NAMES.PROJECT_PLAN,
		BLUEPRINT_NAMES.STRATEGIC_PLAN,
		WHITEBOARD_TEMPLATE_IDS.SIMPLE_RETROSPECTIVE,
		BLUEPRINT_NAMES.PROJECT_STATUS,
		BLUEPRINT_NAMES.DACI_DECISION_DOCUMENTATION,
		BLUEPRINT_NAMES.PROJECT_KICKOFF,
	],
	SPREADSHEET: [
		BLUEPRINT_NAMES.TO_DO_LIST,
		WHITEBOARD_TEMPLATE_IDS.TIMELINE_WORKFLOW,
		BLUEPRINT_NAMES.END_OF_WEEK_STATUS_REPORT,
	],
	'MIND MAP': [
		WHITEBOARD_TEMPLATE_IDS.SWIMLANES_PROCESS_MAP,
		WHITEBOARD_TEMPLATE_IDS.CONCEPT_MAP,
		WHITEBOARD_TEMPLATE_IDS.PRODUCT_ROADMAP,
	],
	'PROJECT MANAGEMENT TEMPLATES': [
		BLUEPRINT_NAMES.PROJECT_PLAN,
		BLUEPRINT_NAMES.STRATEGIC_PLAN,
		WHITEBOARD_TEMPLATE_IDS.SIMPLE_RETROSPECTIVE,
		BLUEPRINT_NAMES.PROJECT_STATUS,
		BLUEPRINT_NAMES.DACI_DECISION_DOCUMENTATION,
		BLUEPRINT_NAMES.OKRS,
		BLUEPRINT_NAMES.ROLES_AND_RESPONSIBILITIES,
		BLUEPRINT_NAMES.PROJECT_KICKOFF,
	],
	'ORGANIZATION CHART': [
		WHITEBOARD_TEMPLATE_IDS.ORG_CHART,
		WHITEBOARD_TEMPLATE_IDS.TEAM_CHARTER_TEMPLATE,
		WHITEBOARD_TEMPLATE_IDS.NETWORK_OF_TEAMS,
	],
	'OTHER TEMPLATES': [],
	'TASK MANAGEMENT': [
		WHITEBOARD_TEMPLATE_IDS.ACTION_PLAN,
		BLUEPRINT_NAMES.TO_DO_LIST,
		WHITEBOARD_TEMPLATE_IDS.TIMELINE_WORKFLOW,
		WHITEBOARD_TEMPLATE_IDS.PRIORITIZATION_MATRIX,
		WHITEBOARD_TEMPLATE_IDS.STAKEHOLDER_MAPPING,
	],
	'MARKETING TEMPLATES': [
		BLUEPRINT_NAMES.MARKETING_PLAN,
		BLUEPRINT_NAMES.COMPETITIVE_ANALYSIS,
		WHITEBOARD_TEMPLATE_IDS.USER_STORY_MAP,
		WHITEBOARD_TEMPLATE_IDS.SWOT_ANALYSIS,
		BLUEPRINT_NAMES.PERSONA,
		BLUEPRINT_NAMES.MESSAGE_HOUSE,
		WHITEBOARD_TEMPLATE_IDS.BRAINWRITING,
		WHITEBOARD_TEMPLATE_IDS.TIMELINE_WORKFLOW,
	],
	WHITEBOARD: [
		WHITEBOARD_TEMPLATE_IDS.SIMPLE_RETROSPECTIVE,
		WHITEBOARD_TEMPLATE_IDS.PRIORITIZATION_MATRIX,
		WHITEBOARD_TEMPLATE_IDS.BRAINWRITING,
		WHITEBOARD_TEMPLATE_IDS.ICEBREAKERS,
	],
	'MEETINGS TEMPLATE': [
		BLUEPRINT_NAMES.MEETING_NOTES,
		WHITEBOARD_TEMPLATE_IDS.DISRUPTIVE_BRAINSTORM,
		WHITEBOARD_TEMPLATE_IDS.SIMPLE_RETROSPECTIVE,
		BLUEPRINT_NAMES.SPRINT_PLANNING_MEETING,
		BLUEPRINT_NAMES.PROJECT_KICKOFF,
		WHITEBOARD_TEMPLATE_IDS.ICEBREAKERS,
	],
	'CONTENT MANAGEMENT': [
		BLUEPRINT_NAMES.CONTENT_STRATEGY,
		BLUEPRINT_NAMES.WRITING_GUIDELINES,
		BLUEPRINT_NAMES.CONTENT_DESIGN_GLOSSARY,
		BLUEPRINT_NAMES.DESIGN_SYSTEMS,
	],
	'PROCESS MANAGEMENT': [
		BLUEPRINT_NAMES.WEEKLY_MEETING_NOTES,
		WHITEBOARD_TEMPLATE_IDS.SWIMLANES_PROCESS_MAP,
		BLUEPRINT_NAMES.HOW_TO_ARTICLE,
		BLUEPRINT_NAMES.STANDARD_OPERATING_PROCEDURE_TEMPLATE,
		WHITEBOARD_TEMPLATE_IDS.INCIDENT_POSTMORTEM,
	],
	'PROJECT MANAGEMENT SOFTWARE': [
		BLUEPRINT_NAMES.PROJECT_PLAN,
		BLUEPRINT_NAMES.STRATEGIC_PLAN,
		WHITEBOARD_TEMPLATE_IDS.SIMPLE_RETROSPECTIVE,
		BLUEPRINT_NAMES.PROJECT_STATUS,
		BLUEPRINT_NAMES.DACI_DECISION_DOCUMENTATION,
		BLUEPRINT_NAMES.ROLES_AND_RESPONSIBILITIES,
		BLUEPRINT_NAMES.PROJECT_KICKOFF,
		BLUEPRINT_NAMES.PROJECT_TIMELINE_TEMPLATE,
		BLUEPRINT_NAMES.STANDARD_OPERATING_PROCEDURE_TEMPLATE,
	],
	'KNOWLEDGE MANAGEMENT': [
		BLUEPRINT_NAMES.HOW_TO_ARTICLE,
		BLUEPRINT_NAMES.HR_KNOWLEDGE_BASE_MANAGEMENT,
		BLUEPRINT_NAMES.ITSM_KNOWN_ERRORS,
		WHITEBOARD_TEMPLATE_IDS.SERVICE_BLUEPRINT,
		BLUEPRINT_NAMES.TROUBLESHOOTING_ARTICLE,
		BLUEPRINT_NAMES.VISION_TO_VALUES,
		BLUEPRINT_NAMES.EMPLOYEE_HANDBOOK,
	],
	'GANTT CHART': [
		BLUEPRINT_NAMES.PROJECT_TIMELINE_TEMPLATE,
		WHITEBOARD_TEMPLATE_IDS.TIMELINE_WORKFLOW,
		BLUEPRINT_NAMES.PROJECT_PLAN,
	],
	BRAINSTORM: [
		WHITEBOARD_TEMPLATE_IDS.DISRUPTIVE_BRAINSTORM,
		BLUEPRINT_NAMES.DESIGN_SPRINT,
		WHITEBOARD_TEMPLATE_IDS.PRODUCT_VISION_BOARD,
		WHITEBOARD_TEMPLATE_IDS.PRIORITIZATION_MATRIX,
	],
	MEETINGS: [
		BLUEPRINT_NAMES.MEETING_NOTES,
		WHITEBOARD_TEMPLATE_IDS.DISRUPTIVE_BRAINSTORM,
		WHITEBOARD_TEMPLATE_IDS.SIMPLE_RETROSPECTIVE,
		BLUEPRINT_NAMES.SPRINT_PLANNING_MEETING,
		BLUEPRINT_NAMES.PROJECT_KICKOFF,
		WHITEBOARD_TEMPLATE_IDS.ICEBREAKERS,
	],
	WORKFLOW: [
		BLUEPRINT_NAMES.STANDARD_OPERATING_PROCEDURE_TEMPLATE,
		WHITEBOARD_TEMPLATE_IDS.WORKFLOW_TEMPLATE,
		BLUEPRINT_NAMES.OKRS,
	],
	'TEAM MANAGEMENT': [
		BLUEPRINT_NAMES.VIRTUAL_EVENT,
		WHITEBOARD_TEMPLATE_IDS.ICEBREAKERS,
		BLUEPRINT_NAMES.TEAM_POSTER,
		WHITEBOARD_TEMPLATE_IDS.TEAM_HEALTH_MONITOR,
		BLUEPRINT_NAMES.QUARTERLY_CHECK_IN,
		BLUEPRINT_NAMES.DACI_DECISION_DOCUMENTATION,
		BLUEPRINT_NAMES.WORKSHOP_PLANNER,
		WHITEBOARD_TEMPLATE_IDS.TEAM_CHARTER_TEMPLATE,
		WHITEBOARD_TEMPLATE_IDS.FOURLS_RETRO,
		BLUEPRINT_NAMES.WORK_TRIP_PLANNER,
	],
	'WORK MANAGEMENT': [
		BLUEPRINT_NAMES.CAREER_DEVELOPMENT_PLAN,
		WHITEBOARD_TEMPLATE_IDS.TEAM_CHARTER_TEMPLATE,
		BLUEPRINT_NAMES.HR_KNOWLEDGE_BASE_MANAGEMENT,
		WHITEBOARD_TEMPLATE_IDS.SIMPLE_RETROSPECTIVE,
		WHITEBOARD_TEMPLATE_IDS.ROOT_CAUSE_TEMPLATE,
		WHITEBOARD_TEMPLATE_IDS.NETWORK_OF_TEAMS,
	],
	INTRANET: [
		BLUEPRINT_NAMES.HOW_TO_ARTICLE,
		BLUEPRINT_NAMES.HR_KNOWLEDGE_BASE_MANAGEMENT,
		WHITEBOARD_TEMPLATE_IDS.ORG_CHART,
		BLUEPRINT_NAMES.TEAM_HOMEPAGE,
		BLUEPRINT_NAMES.VISION_TO_VALUES,
		WHITEBOARD_TEMPLATE_IDS.NETWORK_OF_TEAMS,
	],
	'TIME MANAGEMENT': [
		BLUEPRINT_NAMES.PROJECT_TIMELINE_TEMPLATE,
		WHITEBOARD_TEMPLATE_IDS.TIMELINE_WORKFLOW,
	],
	'COMMUNICATION SYSTEM': [
		BLUEPRINT_NAMES.STAKEHOLDER_COMMUNICATIONS,
		BLUEPRINT_NAMES.INCIDENT_COMMUNICATION,
		WHITEBOARD_TEMPLATE_IDS.SERVICE_BLUEPRINT,
		WHITEBOARD_TEMPLATE_IDS.INCIDENT_POSTMORTEM,
		WHITEBOARD_TEMPLATE_IDS.TEAM_HEALTH_MONITOR,
	],
	'PROJECT REPORTING': [
		WHITEBOARD_TEMPLATE_IDS.EXECUTIVE_SUMMARY,
		BLUEPRINT_NAMES.STAKEHOLDER_COMMUNICATIONS,
		BLUEPRINT_NAMES.PROJECT_STATUS,
		WHITEBOARD_TEMPLATE_IDS.TEAM_HEALTH_MONITOR,
		BLUEPRINT_NAMES.OKRS,
	],
	REMOTE: [
		BLUEPRINT_NAMES.REMOTE_TEAM_MEETING,
		WHITEBOARD_TEMPLATE_IDS.ICEBREAKERS,
		BLUEPRINT_NAMES.VIRTUAL_EVENT,
		WHITEBOARD_TEMPLATE_IDS.TEAM_HEALTH_MONITOR,
		BLUEPRINT_NAMES.EMPLOYEE_HANDBOOK,
		WHITEBOARD_TEMPLATE_IDS.FOURLS_RETRO,
		BLUEPRINT_NAMES.WORKSHOP_PLANNER,
	],
} as const;
